import { create } from 'zustand';
import { KeywordFilter } from '../components/Summary/Visualizations/types';

interface ContentAnalyticState {
  keywordFilter: KeywordFilter;
  setKeywordFilter: (filter: KeywordFilter) => void;
}

export const useContentAnalyticStore = create<ContentAnalyticState>((set) => ({
  keywordFilter: KeywordFilter.Usage,
  setKeywordFilter: (filter: KeywordFilter) => {
    set({ keywordFilter: filter });
  }
}));
